<div class="container spanning-content">
  <div class="breadcrumb-item" *ngFor="let item of data.paths">
    <a routerLink="{{item.url}}" class="breadcrumb-text" title="{{item.name}}">{{item.name}}</a>
    <mat-icon>keyboard_arrow_right</mat-icon>
  </div>
  <p class="breadcrumb-text">{{data.current.name}}</p>
  <div class="spacer"></div>
</div>